module.exports = __webpack_public_path__ + "img/a.cd7392a9.png";